import { Component, OnInit, Inject } from '@angular/core';
import {
  MatLegacyDialogRef as MatDialogRef,
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
} from '@angular/material/legacy-dialog';

@Component({
  selector: 'app-more-details-dialog',
  templateUrl: './more-details-dialog.component.html',
  styleUrls: ['./more-details-dialog.component.scss'],
})
export class MoreDetailsDialog implements OnInit {
  moreDetails: any;

  constructor(
    private _dialogRef: MatDialogRef<MoreDetailsDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.moreDetails = this.data.details;
  }

  close() {
    this._dialogRef.close('close');
  }
}
